import React, {useState} from 'react';
import {Slide, SwipeableDrawer} from '@mui/material';
import Box from '../../../Common/Box';
import Paper from '@mui/material/Paper';
import {ThemeSettings} from './settings/ThemeSettings';
import {CloudView} from './CloudView';
import ThemeSelect from './ThemeSelect';
import {observer} from 'mobx-react';
import {ThemeJson} from './ThemeJson';
import {ThemeManagerContext} from "../../../Common/Contexts";
import uiStore from "../../stores/uiStore";
import {MobileThemeSettings} from "./settings/MobileThemeSettings";

interface ThemeManagerProps {
    withThemeSelect?: boolean;
    children?: React.ReactNode;
}

export default observer(function ThemeManager(
        {
            withThemeSelect = true,
            children
        }: ThemeManagerProps
) {

    const [paletteVisible, setPaletteVisible] = useState(false);
    const [cloudVisible, setCloudVisible] = useState(false);
    const [tabIndex, setTabIndex] = React.useState(0);

    const tabs = [{
        name: "Theme",
        component: MobileThemeSettings,
    },
        {
            name: "User themes",
            component: CloudView,
        },
        {
            name: "JSON",
            component: ThemeJson,
        },
    ]

    const CurrentComponent = tabs[tabIndex].component;

    if (uiStore.isMobile) {

        return <ThemeManagerContext.Provider value={{paletteVisible, setPaletteVisible, cloudVisible, setCloudVisible}}>

            {children}
            <Box
                    sx={{
                        position: "fixed",
                        flex: 1,
                        pointerEvents: "none",
                        zIndex: 10000000,
                    }}
                    expand
            >
                <SwipeableDrawer
                        sx={{
                            pointerEvents: "none",
                        }}
                        slotProps={{
                            backdrop: {
                                invisible: true,
                                // pointerEvents: "none",
                            }
                        }}
                        anchor={"bottom"}
                        open={uiStore.themeManagerVisible}
                        onOpen={() => uiStore.themeManagerVisible = true}
                        onClose={() => uiStore.themeManagerVisible = false}
                        PaperProps={{
                            sx: {
                                width: "100%",
                                overflow: "initial"
                            },
                        }}
                >
                    <MobileThemeSettings/>
                </SwipeableDrawer>
            </Box>
        </ThemeManagerContext.Provider>
    }

    return <ThemeManagerContext.Provider
            value={{
                paletteVisible,
                setPaletteVisible,
                cloudVisible,
                setCloudVisible
            }}
    >
        {children}
        <Box
                sx={{
                    pointerEvents: "none",
                    zIndex: 100000,
                }}
                flex={1}
                position={"fixed"}
                expand>

            {withThemeSelect && <Box
                    row
                    center
                    height={"100px"}
                    width={"100%"}
                    position={"absolute"}>
                <ThemeSelect withControls/>
            </Box>}

            <Slide direction="right" in={paletteVisible}>
                <ThemeJson/>
            </Slide>

            <Slide direction="left" in={paletteVisible}
            >
                <Paper
                        elevation={5}
                        sx={{
                            pointerEvents: "all",
                            position: "absolute",
                            right: "0", width: "25%", height: "100%"
                        }}>
                    <ThemeSettings/>
                </Paper>
            </Slide>
            <Slide direction="left" in={cloudVisible}>
                <Paper
                        elevation={5} sx={{
                    pointerEvents: "all",
                    zIndex: 11,
                    position: "absolute", right: "0", width: "25%", height: "100%"
                }}>
                    <CloudView/>
                </Paper>
            </Slide>
        </Box>
    </ThemeManagerContext.Provider>
})

